import logo from './logo.svg';
import './App.css';
import { useState } from 'react';
import { speak } from './speechSynth';

function App() {
  const [text, setText] = useState('');
  const [speed, setSpeed] = useState(1);

  return (
    <div className="App">
      <header className="App-header">
        <p>
          Text To Speech English
        </p>
        <textarea placeholder="Type what to speak" onChange={(e) => setText(e.target.value)}/>
        <input id='speed' type="range" min={0.1} max={3} step={0.1} placeholder="Speed" onChange={(e) => setSpeed(e.target.value)} />
        <label htmlFor="speed">{speed}x</label>
        <button onClick={() => speak(text, speed, 'en')}>Speak</button>
      </header>
    </div>
  );
}

export default App;
